"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_padlock__close(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "7eaea721-b00a-4072-b797-fa669970f460",
    "data-name": "security-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192.02 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "92bcf0ce-41fe-4fb1-a10a-4bc1b5123f93",
    x1: 90.94,
    y1: 120.85,
    x2: 148.35,
    y2: 178.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "security-hi"), /*#__PURE__*/React.createElement("g", {
    id: "52109e93-2e4f-4dc6-b271-3a9c2b7fc738",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8cdf295a-e34b-43f4-8d59-846b469e0541",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f04a4f1e-c19c-419e-9798-afb232a8c18b",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "98d31426-36f3-4257-9061-e5c846c2636d",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "749a5d60-4577-4f1b-9a0f-15e48a471d4c",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f01fd673-b42c-4857-b80d-a42cb48b2100",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5f4eed7e-321e-4c06-8dd6-a0afebb03735",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2f30d59-6888-4c1c-94e2-f33b7e910344",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1d61a220-a76e-47e1-95d9-c505a8716aba",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "122d315f-e3ee-4647-b467-7d7f50199c6a",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e75e075-9233-48d0-b89c-8f875ccee23b",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cd5e8c9d-4af4-4c29-adbb-b5eb61eff957",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "addeab1c-9ffe-4566-85ee-dea53f25952d",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "66baf23e-f92d-4710-9211-4b534a9830d3",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e1ba4a1d-c0c2-4eae-b1d4-af8852b4c511",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e5a2f3a0-3a49-45db-ad8b-7b4dc27195d7",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "514e917d-bc84-4d66-908e-2b8b9505fb06",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e9966d52-8519-4aa4-9047-b68f767e0577",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "325b7c31-3e1d-4e7c-af3b-889c57db7290",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14ffd1e8-1460-4b8f-af2e-d474bfd87fe6",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bd5bd7ff-4e3e-4413-ad8c-1bd9182b82ad",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fe609e8d-34f2-4c99-abe1-019fbc417710",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128,76h-8V48a24,24,0,0,0-48,0V76H64V48a32,32,0,0,1,64,0Z",
    transform: "translate(0.01 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "3970f2d9-3520-4aa7-b3db-61de43ebd163",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,46a24,24,0,0,0-48,0v2a24,24,0,0,1,48,0Z",
    transform: "translate(0.01 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.83,
    y: 72,
    width: 128.17,
    height: 104,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.02,
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,174H47.82a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16v-2A16,16,0,0,1,144,174Z",
    transform: "translate(0.01 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,107.36a9.82,9.82,0,0,1,9.75,8.7c0-.3.06-.59.06-.89a9.81,9.81,0,1,0-19.62,0,8.89,8.89,0,0,0,.07.89A9.8,9.8,0,0,1,96,107.36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,105.36a9.81,9.81,0,0,1,4,18.76V148a4,4,0,0,1-8,0V124.12a9.81,9.81,0,0,1,4-18.76m0-4a13.81,13.81,0,0,0-8,25.06V148a8,8,0,0,0,16,0V126.42a13.81,13.81,0,0,0-8-25.06Z",
    transform: "translate(0.01 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,115.17a9.81,9.81,0,1,0-13.81,9V148a4,4,0,0,0,8,0V124.12A9.81,9.81,0,0,0,105.82,115.17Z",
    transform: "translate(0.01 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,105.36a9.81,9.81,0,0,1,4,18.76V148a4,4,0,0,1-8,0V124.12a9.81,9.81,0,0,1,4-18.76m0-4a13.81,13.81,0,0,0-8,25.06V148a8,8,0,0,0,16,0V126.42a13.81,13.81,0,0,0-8-25.06Z",
    transform: "translate(0.01 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.06,105.73a13.77,13.77,0,0,1-2,20.69V148a8,8,0,0,1-8,8,7.8,7.8,0,0,1-3.7-.92L114,176h30a16,16,0,0,0,16-16v-3Z",
    transform: "translate(0.01 0)",
    fill: "url(#92bcf0ce-41fe-4fb1-a10a-4bc1b5123f93)"
  })))))))))))))))))))))))));
}

var _default = ic_padlock__close;
exports.default = _default;